// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3-hrP","productName":"Table_productName__2rlFo"};